/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

import { EntityLabel } from "./entity-label";

/**
 * Entity object. This object has a entity type, properties, confidence and an id
 */
type Entity = {
  type: string;
  properties: Entity[];
  confidence?: number;
  id?: string;
};

/**
 * Classification label used when classifying a document
 */
export class ClassificationLabel {
  label: string = "Document type";
  values: EntityLabel[];
  id?: string;
  selectedValue?: string;

  constructor(values: EntityLabel[] = []) {
    this.values = values;
  }

  static fromJson(json: any): ClassificationLabel {
    const classificationLabel = new ClassificationLabel(      
      json.values
    );
    return classificationLabel;
  }
}

/**
 * Get entity labels for entity dropdown list from list of document entities
 * @param entities 
 * @returns 
 */
export function convertEntitiesToClassificationLabels(
  entities: Entity[]
): ClassificationLabel[] {
  const classificationLabel = new ClassificationLabel();
  let maxEntityConfidence = 0;
  entities?.forEach((entity: Entity) => {
    // don't add entity if it already exists in the values of the classificationLabel
    if (!classificationLabel.values.some((value) => value.label === entity.type)) {
      if (entity.confidence ?? 0 >= maxEntityConfidence) {
        maxEntityConfidence = entity.confidence ?? 0;
        classificationLabel.selectedValue = entity.type;
        classificationLabel.id = entity.id;
      }
    }
  });
  return [classificationLabel];
}
